import * as React from "react";

export type WithAsChild<TProps> = TProps & {
  asChild?: boolean;
  children?: React.ReactNode;
};

export function renderAsChild(asChild: boolean | undefined, children: React.ReactNode) {
  return asChild && React.isValidElement(children) ? children : undefined;
}
